import { render } from "./domain-modal.vue?vue&type=template&id=7b64712e"
import script from "./domain-modal.vue?vue&type=script&lang=js"
export * from "./domain-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__